export default "__VITE_ASSET__4c75ce93__"